import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=51b329ce"
import script from "./FileManager.vue?vue&type=script&lang=ts"
export * from "./FileManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports